import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Divider, Icon, Row, Col, message, Calendar, Button, Dropdown, Menu, Modal, Popover, DatePicker } from 'antd';
import { getCookie } from './../../hook';
import _ from 'underscore';
import moment from 'moment';
import { CSVLink  } from 'react-csv';
import Papa from 'papaparse';

import './style.css';

// Actions
import { get_meetings, save_meetings, delete_meetings, get_meetings_by_id, update_meetings } from './actions/meetings.action';

// Childs
import NewMeetings from './childs/new.meetings';
import EditMeetings from './childs/edit.meetings';

const confirm = Modal.confirm;
const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

class Meetings extends Component {

    constructor( props ){
        super( props )

        this.state = {
            data: [],
            meeting_data: [],
            new_meetings_model: false,
            edit_meetings_model: false,
            visible: false,
            download_csv: []
        }

        this.dateCellRender = this.dateCellRender.bind( this );
        this.getListData = this.getListData.bind( this );
        this.handleMeetings = this.handleMeetings.bind( this );
        this.handleSubmitMeetings = this.handleSubmitMeetings.bind( this );
        this.handleMeetingSelection = this.handleMeetingSelection.bind( this );
        this.handleUpdateMeetings = this.handleUpdateMeetings.bind( this );
        this.calcTimeDuration = this.calcTimeDuration.bind( this );
        this.handleDownload = this.handleDownload.bind( this );

    }

    handleDownload( date, dateString ){

        if( dateString ){

            let start_date = dateString[0];
            let end_date = dateString[1];
            let tempData = this.state.data;
            let data = [];
            let final_data = [];

            tempData.map(( item, i ) => {
                if( this.dateCheck( start_date, end_date, item.date ) ){
                    data.push( item );
                }
            });

            data.map( ( item, i ) => {
                let stack = {
                    'name': item.sales_manager,
                    'date': item.date,
                    'meeting_in': item.time_in,
                    'meeting_out': item.time_out,
                    'meeting_out_duration': this.calcTimeDuration( item.time_out, item.time_in ),
                    'agency': item.agency,
                    'purpose_of_visit': item.purpose_of_visit,
                    'meeting_outcome': item.meeting_outcome
                }

                final_data.push( stack );

            });

            let csvData = Papa.unparse( final_data );
            let filename = start_date + '-' + end_date + 'meetings.csv';

            var link = window.document.createElement("a");
            link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvData));
            link.setAttribute("download", filename );
            link.click();

        }

    }

    dateCheck( start_date, end_date, current_date ){

        let D1 = new Date( start_date ); 
        let D2 = new Date( end_date ); 
        let D3 = new Date( current_date );

        if ( D3.getTime() <= D2.getTime() && D3.getTime() >= D1.getTime() ) {
            return true;
        } else {
            return false;
        }

    }

    calcTimeDuration( time_out, time_in ){

        var now  = time_in;
        var then = time_out;
        
        var ms = moment(now,"HH:mm a").diff(moment(then,"HH:mm a"));
        var d = moment.duration(ms);
        
        return d.hours()+":"+d.minutes()+ ' hrs'

    }

    dateCellRender( value ) {

        const user = getCookie('dv_hrms_user').split(',');
        const list_dates = this.getListData( value );

        return (
            <span>
                {
                    list_dates.map( ( item, i ) => {

                        if( item.user_id !== user[1] ){
                            return <Popover trigger="click" key={ i } content={
                                <div style={{ width: '300px' }}>

                                    <Row>
                                        <Col span={12}>&nbsp;</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Sales Manager</b></Col>
                                        <Col span={12}>{ item.sales_manager }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Agency</b></Col>
                                        <Col span={12}>{ item.agency }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Date</b></Col>
                                        <Col span={12}>{ item.date }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Time Out</b></Col>
                                        <Col span={12}>{ item.time_out }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Time In</b></Col>
                                        <Col span={12}>{ item.time_in }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Duration of Meeting</b></Col>
                                        <Col span={12}>{ this.calcTimeDuration( item.time_out, item.time_in )  }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Purpose of Visit</b></Col>
                                        <Col span={12}>{ item.purpose_of_visit }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Meeting Outcome</b></Col>
                                        <Col span={12}>{ item.meeting_outcome }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}>&nbsp;</Col>
                                    </Row>

                                </div>
                            }>
                            <span className="meetings" id={ item.id } >
                                { item.sales_manager }
                                <em>
                                    { item.time_out }
                                    &nbsp; - &nbsp;
                                    { item.time_in }
                                </em>
                            </span>
                            </Popover>
                        } else {
                            return <Popover trigger="click" key={ i } content={
                                <div style={{ width: '300px' }}>

                                    <Row>
                                        <Col span={12}>&nbsp;</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Sales Manager</b></Col>
                                        <Col span={12}>{ item.sales_manager }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Agency</b></Col>
                                        <Col span={12}>{ item.agency }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Date</b></Col>
                                        <Col span={12}>{ item.date }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Time Out</b></Col>
                                        <Col span={12}>{ item.time_out }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Time In</b></Col>
                                        <Col span={12}>{ item.time_in }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Duration of Meeting</b></Col>
                                        <Col span={12}>{ this.calcTimeDuration( item.time_out, item.time_in )  }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Purpose of Visit</b></Col>
                                        <Col span={12}>{ item.purpose_of_visit }</Col>
                                    </Row>

                                    <Row>
                                        <Col span={12}><b>Meeting Outcome</b></Col>
                                        <Col span={12}>{ item.meeting_outcome }</Col>
                                    </Row>
                                    <Row>
                                        <Col span={12}>&nbsp;</Col>
                                    </Row>

                                </div>
                            }><Dropdown key={ i } overlay={
                                <Menu onClick={ this.handleMeetingSelection }>
                                    <Menu.Item key="1" id={ item.id }>
                                        Edit
                                    </Menu.Item>
                                    <Menu.Item key="2" id={ item.id }>
                                        Delete
                                    </Menu.Item>
                                </Menu>
                            } trigger={[ 'click' ]}>
                                <span className="meetings" id={ item.id } >
                                    { item.sales_manager }
                                    <em>
                                        { item.time_out }
                                        &nbsp; - &nbsp;
                                        { item.time_in }
                                    </em>
                                </span>
                            </Dropdown>
                            </Popover>
                        }

                    })
                }
            </span>
        );

    }

    getListData( value ){

        let list_data= [];
        let current_date = moment( value ).format( 'YYYY-MM-DD' );

        _.map( this.state.data, ( data, i ) => { 
            if( data.date === current_date ){
                list_data.push( 
                    { 
                        id: data.meeting_id,
                        date: data.date,
                        user_id: data.user_id,
                        sales_manager: data.sales_manager,
                        time_out: data.time_out,
                        time_in: data.time_in,
                        agency: data.agency,
                        purpose_of_visit: data.purpose_of_visit,
						meeting_outcome: data.meeting_outcome
                    }
                );
                return false;
            }
        });

        return list_data;

    }

    handleMeetingSelection( e ){
        let self = this;

        if( e.key === '2' ){
            if( e.item.props.id !== 0 ){

                confirm({
                    title: 'Do you Want to delete This Meeting?',
                    onOk() {
                        self.props.delete_meetings( e.item.props.id );
                    },
                    onCancel() {
                        // Nothing
                    },
                });
                
            }
        } else if( e.key === '1' ){
            if( e.item.props.id !== 0 ){
                this.props.get_meetings_by_id( e.item.props.id )
            }
        }

    }

    handleMeetings(){
        this.setState({
            new_meetings_model: true,
            edit_meetings_model: false
        });
    }

    handleSubmitMeetings( data ){
        this.props.save_meetings( data );
    }

    handleUpdateMeetings( data ){
        this.props.update_meetings( data );
    }

    componentWillMount(){
        const user = getCookie('dv_hrms_user').split(',');
        this.setState({ users: user[6] });
        this.props.get_meetings( user[6] );
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.meetings.length === 0 ){
            console.log( 'Slow Data Fetching ...' )
            return false;
        }

        if( nextProps.meetings.STATUS.CODE === "200" && 
            nextProps.meetings.STATUS.MESSAGE === "Successfully Listed Meetings" ) {

            this.setState({
                data: nextProps.meetings.OUTPUT.DATA,
                new_meetings_model: false,
                edit_meetings_model: false
            });

        } else if( nextProps.meetings.STATUS.CODE === "200" && 
            nextProps.meetings.STATUS.MESSAGE === "Successfully Saved Meetings" ) {

            message.success( nextProps.meetings.STATUS.MESSAGE );
            
            this.setState({
                new_meetings_model: false,
                edit_meetings_model: false
            });

            this.props.get_meetings( this.state.users );

        } else if( nextProps.meetings.STATUS.CODE === "200" && 
            nextProps.meetings.STATUS.MESSAGE === "Successfully Deleted Meetings" ){
            
            message.success( nextProps.meetings.STATUS.MESSAGE );

            this.setState({
                new_meetings_model: false,
                edit_meetings_model: false
            });

            this.props.get_meetings( this.state.users );

        }  else if( nextProps.meetings.STATUS.CODE === "200" && 
            nextProps.meetings.STATUS.MESSAGE === "Successfully Listed Meeting by id" ){

            this.setState({
                meeting_data: nextProps.meetings.OUTPUT.DATA,
                new_meetings_model: false,
                edit_meetings_model: true
            });

        } else if( nextProps.meetings.STATUS.CODE === "200" && 
            nextProps.meetings.STATUS.MESSAGE === "Successfully Updated Meetings" ){

            message.success( nextProps.meetings.STATUS.MESSAGE );

            this.setState({
                new_meetings_model: false,
                edit_meetings_model: false
            });

            this.props.get_meetings( this.state.users );

        }


        
    }

    handleVisibleChange = visible => {
        this.setState({ visible });
    }

    render() {
        return (
            <div className="meetings_wrapper">
                
                <Row>
                    <Col span={12}>
                        <h2>
                            <Icon type="calendar" />
                            &nbsp; Meetings
                        </h2>
                    </Col>
                    <Col span={12}>

                        <Button
                            onClick={ this.handleMeetings }
                            className="fl_right" 
                            type="primary" 
                            icon="calendar">
                            Schedule Meeting
                        </Button>

                        <Popover
                            content={ <RangePicker onChange={ this.handleDownload } /> }
                            title="Select Date Range"
                            trigger="click"
                            visible={this.state.visible}
                            onVisibleChange={this.handleVisibleChange}
                            placement="bottom">
                            <Button
                                className="fl_right"
                                icon="download"
                                style={{ marginRight: '10px' }}
                                onClick={ this.handleDownload }>
                                Download
                            </Button>
                        </Popover>

                    </Col>
                </Row>

                <Divider />

                <Row>
                    <Col span={24}>
                        <Calendar dateCellRender={ this.dateCellRender } />
                    </Col>
                </Row>

                <NewMeetings onSubmit={ this.handleSubmitMeetings } onModel={ this.state.new_meetings_model } />
                <EditMeetings data={ this.state.meeting_data } onSubmit={ this.handleUpdateMeetings } onModel={ this.state.edit_meetings_model } />

            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        meetings: state.meetings
    }
}

export default connect( mapStatetoProps, { get_meetings, save_meetings, delete_meetings, get_meetings_by_id, update_meetings })( Meetings );


// WEBPACK FOOTER //
// ./src/pages/meetings/index.js